import React from 'react';
const Footer: React.FC = () => {
  return <footer className="w-full py-12 px-4 bg-gray-900" data-id="element-66">
      <div className="max-w-5xl mx-auto" data-id="element-67">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-68">
          <div data-id="element-69">
            <h3 className="text-lg font-semibold mb-4" data-id="element-70">Naturliga lösningar</h3>
            <p className="text-sm text-gray-400" data-id="element-71">
              Naturliga ingredienser för bättre sexuell prestationsförmåga,
              kraftigare erektioner och ökad sexlust.
            </p>
          </div>
          <div data-id="element-72">
            <h3 className="text-lg font-semibold mb-4" data-id="element-73">Ingredienser</h3>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-74">
              <li data-id="element-75">Epimedium Icariin (Horny Goat Weed)</li>
              <li data-id="element-76">Eurycoma longifolia (Longjack)</li>
              <li data-id="element-77">Serenoa Repens</li>
              <li data-id="element-78">Nässelrot</li>
            </ul>
          </div>
          <div data-id="element-79">
            <h3 className="text-lg font-semibold mb-4" data-id="element-80">Expertutlåtande</h3>
            <p className="text-sm text-gray-400" data-id="element-81">
              "Den unika formeln hos våra kosttillskott möter högsta
              internationella standard gällande kvalitet och säkerhet. Dess
              ingredienser är de bästa möjliga för att ge mer intensiva
              erektioner, hög sexuell njutning och penishälsa."
            </p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center" data-id="element-82">
          <p className="text-xs text-gray-500 mt-4" data-id="element-83">
            © 2023 Alla rättigheter förbehållna.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;